import React from "react";
import {connect} from "react-redux";
import {formValueSelector, reduxForm} from "redux-form";
import {ff, form} from "@mc/mc-legacy";
import EnumSignLevel from "../../api/gen/qsign/types/EnumSignLevel";
import EnumSignSource from "../../api/gen/qsign/types/EnumSignSource";
import EnumTimestampSource from "../../api/gen/qsign/types/EnumTimestampSource";
import EnumTimestampLevel from "../../api/gen/qsign/types/EnumTimestampLevel";

const { Form, FormActions, FormBody } = form;

const validate = (formData) => {
  const errors = {};

  if (!formData.connectorName) {
    errors.connectorName = "Název musí být vyplněný";
  }

  if (!formData.level) {
    errors.level = "Úroveň musí být vyplněná";
  }

  if (!formData.source) {
    errors.source = "Typ musí být vyplněný";
  }

  if (formData.source === "REMSIG") {
    if (!formData.login) {
      errors.login = "Login musí být vyplněný";
    }

    if (!formData.url) {
      errors.url = "URL musí být vyplněná";
    }

    if (!formData.password) {
      errors.password = "Heslo musí být vyplněné";
    }
  }

  if (formData.razitko) {
    if (!formData.razitkoConnectorName) {
      errors.razitkoConnectorName = "Název musí být vyplněný";
    }

    if (!formData.levelRazitko) {
      errors.levelRazitko = "Úroveň musí být vyplněná";
    }

    if (!formData.sourceRazitko) {
      errors.sourceRazitko = "Typ musí být vyplněný";
    }

      if (formData.sourceRazitko == EnumTimestampSource.TSA && !formData.tsUrl) {
          errors.tsUrl = "Url adresa musí být vyplněná";
      }
  }

  return errors;
};
/* const validate = () => {
    const errors = {};
    return errors;
}; */

class PodepisovaniForm extends React.Component {
  static formName = "PodepisovaniForm";
  itemsLevel = [
    {
      id: EnumSignLevel.QUALIFIED,
      name: "Kvalifikovaný",
    },
    {
      id: EnumSignLevel.GUARANTEED,
      name: "Zaručený",
    },
  ];

  itemsLevelRazitko = [
    {
      id: EnumTimestampLevel.QUALIFIED,
      name: "Kvalifikovaný",
    },
    {
      id: EnumTimestampLevel.GUARANTEED,
      name: "Zaručený",
    },
  ];
  mcItemsSourceRazitko = [
        {
            id: EnumTimestampSource.TSA,
            name: "TSA",
        }
    ];
  itemsSourceRazitko = [
    {
      id: EnumTimestampSource.TSA,
      name: "TSA",
    },
    {
      id: EnumTimestampSource.REMSIG,
      name: "Remsig",
    },
  ];
  ZobrazitRemsig() {
    return this.props.level === "GUARANTEED"
      ? [
          {
            id: EnumSignSource.MC,
            name: "Marbes",
          },
        ]
      : [
          {
            id: EnumSignSource.MC,
            name: "Marbes",
          },
          {
            id: EnumSignSource.REMSIG,
            name: "Remsig",
          },
        ];
  }

  isRemsig() {
    return this.props.source && this.props.source == "REMSIG";
  }

  isRemsigTlacitko() {
    return this.props.sourceRazitko && this.props.sourceRazitko == "REMSIG";
  }

  isTSA() {
    return this.props.sourceRazitko && this.props.sourceRazitko == "TSA";
  }

  isMC() {
    return this.props.source && this.props.source == EnumSignSource.MC;
  }

  onChangesource() {
    this.props.change("url", null);
    this.props.change("login", null);
    this.props.change("password", null);
    this.props.change("razitko", false);
    this.onChangeRazitko();
  }

  onChangelevel() {
    this.props.change("source", null);
    this.onChangesource();
  }

  onChangeRazitko() {
    this.props.change("levelRazitko", null);
    this.props.change("sourceRazitko", null);
    this.props.change("razitkoConnectorName", null);
    this.onChangeSourceRazitko();
  }

  onChangeSourceRazitko() {
    this.props.change("tsUrl", null);
    this.props.change("tsLogin", null);
    this.props.change("tsPassword", null);
    this.props.change("tsCertPath", null);
    this.props.change("tsCertPassword", null);
    this.props.change("tsTimeout", null);
  }

  render() {
    const { onClose, submitting, values, change, handleSubmit } = this.props;
    return (
      <Form onSubmit={handleSubmit}>
        <FormBody>
          <ff.String required name="connectorName" label="Název" />
          {this.props.connectorName && (
            <ff.Autocomplete
              useIdAsValue={true}
              required
              name="level"
              label="Úroveň"
              onChange={() => {
                this.onChangelevel();
              }}
              items={this.itemsLevel}
            />
          )}
          {this.props.level && (
            <ff.Autocomplete
              required
              useIdAsValue={true}
              name="source"
              label="Typ"
              onChange={() => {
                this.onChangesource();
              }}
              items={this.ZobrazitRemsig()}
            />
          )}
          {this.isRemsig() && (
            <div>
              <ff.String required name="url" label="Url" />
              <ff.String required name="login" label="Přihlašovací jméno" />
              <ff.String required name="password" type="password" label="Heslo" />
            </div>
          )}
          {this.props.source && (
            <ff.Checkbox
              name="razitko"
              label="Připojení časového razítka"
              onChange={() => {
                this.onChangeRazitko();
              }}
            />
          )}
        </FormBody>
        {this.props.razitko && (
          <FormBody>
            <ff.String name="razitkoConnectorName" label="název" />
            {this.props.razitkoConnectorName && (
              <ff.Autocomplete
                useIdAsValue={true}
                name="levelRazitko"
                required
                label="Úroveň"
                items={this.itemsLevelRazitko}
              />
            )}
            {this.props.levelRazitko && (
              <ff.Autocomplete
                name="sourceRazitko"
                required
                onChange={() => {
                  this.onChangeSourceRazitko();
                }}
                label="Typ"
                useIdAsValue={true}
                items={this.isMC() ? this.mcItemsSourceRazitko : this.itemsSourceRazitko}
              />
            )}
            {this.isTSA() && (
              <div>
                <ff.String required name="tsUrl" label="Url" />
                <ff.String name="tsLogin" label="Přihlašovací jméno" />
                <ff.String name="tsPassword" type="password" label="Heslo" />
                <ff.String name="tsCertPath" label="Cesta k certifikátu" />
                <ff.String name="tsCertPassword" type="password" label="Heslo k certifikátu" />
              </div>
            )}
            {this.isRemsigTlacitko() && (
              <div>
                <ff.String name="tsUrl" label="Url" />
                <ff.String name="tsLogin" label="Přihlašovací jméno" />
                <ff.String name="tsPassword" type="password" label="Heslo" />
                <ff.String name="tsTimeout" label="tsTimeout" />
              </div>
            )}
          </FormBody>
        )}
        <FormActions onClose={onClose} storeButton cancelButton disabled={submitting} />
      </Form>
    );
  }
}

function mapStateToProps(state) {
  const selector = formValueSelector(PodepisovaniForm.formName);
  return {
    connectorId: selector(state, "connectorId"),
    connectorName: selector(state, "connectorName"),
    level: selector(state, "level"),
    source: selector(state, "source"),
    razitko: selector(state, "razitko"),
    levelRazitko: selector(state, "levelRazitko"),
    sourceRazitko: selector(state, "sourceRazitko"),
    url: selector(state, "url"),
    login: selector(state, "login"),
    password: selector(state, "password"),
    tsUrl: selector(state, "tsUrl"),
    tsLogin: selector(state, "tsLogin"),
    tsPassword: selector(state, "tsPassword"),
    tsCertPath: selector(state, "tsCertPath"),
    tsCertPassword: selector(state, "tsCertPassword"),
    tsTimeout: selector(state, "tsTimeout"),
    tsConnectorId: selector(state, "tsConnectorId"),
    razitkoConnectorName: selector(state, "razitkoConnectorName"),
  };
}

export default connect(mapStateToProps)(
  reduxForm({
    initialValues: {},
    form: PodepisovaniForm.formName,
    validate: validate,
  })(PodepisovaniForm)
);
